/* Cart drawer extras (reservation timer, total on the checkout button, savings per line), same as jeffrey-taylor.com */
(function () {
  var cfg = window.cdCart || {}, KEY = 'cd_cart_timer_end';
  function timerEnd(min) {
    var e = +sessionStorage.getItem(KEY);
    if (!e || e < Date.now()) { e = Date.now() + min * 6e4; sessionStorage.setItem(KEY, e); }
    return e;
  }
  function tick() {
    var els = document.querySelectorAll('[data-cd-timer-value]');
    if (!els.length) return;
    var min = +(els[0].closest('[data-cd-timer]') || {}).dataset.minutes || 10;
    var s = Math.max(0, Math.round((timerEnd(min) - Date.now()) / 1e3));
    var t = String(Math.floor(s / 60)).padStart(2, '0') + ':' + String(s % 60).padStart(2, '0');
    els.forEach(function (el) { if (el.textContent !== t) el.textContent = t; });
  }
  function clean(t) { return String(t || '').trim().replace(/\s+[A-Z]{3}$/, ''); }
  function footer() {
    var btn = document.querySelector('#cart-drawer .cart__checkout'), tot = document.querySelector('#cart-drawer [data-cart-total]');
    if (!btn || !tot) return;
    if (/\s[A-Z]{3}\s*$/.test(tot.textContent)) tot.textContent = clean(tot.textContent);
    var labs = document.querySelectorAll('#cart-drawer .cart__total__label'), lab0 = labs[labs.length - 1], T = cfg.total || 'Total';
    if (lab0 && lab0.textContent.trim() !== T) lab0.textContent = T;
    if (cfg.checkout && !btn.querySelector('.cd-btn-label')) {
      Array.prototype.slice.call(btn.childNodes).forEach(function (n) { if (n.nodeType === 3 && n.textContent.trim()) n.remove(); });
      var lab = document.createElement('span'); lab.className = 'cd-btn-label'; lab.textContent = cfg.checkout; btn.appendChild(lab);
    }
    var span = btn.querySelector('.cd-btn-total');
    if (!span) { span = document.createElement('span'); span.className = 'cd-btn-total'; btn.appendChild(span); }
    var v = clean(tot.textContent) ? ' • ' + clean(tot.textContent) : '';
    if (span.textContent !== v) span.textContent = v;
  }
  function num(t) {
    var s = String(t || '').replace(/[^\d.,]/g, '');
    var m = s.match(/^(.*?)[.,](\d{2})$/);
    return m ? parseFloat(m[1].replace(/[.,]/g, '') + '.' + m[2]) : parseFloat(s.replace(/[.,]/g, '')) || 0;
  }
  function fmt(v, tpl) {
    var s = String(tpl || '').trim(), m = s.match(/\d[\d.,]*\d|\d/);
    if (!m) return v.toFixed(2);
    var dec = /[.,]\d{2}$/.test(m[0]) ? m[0].slice(-3, -2) : null, thou = dec === ',' ? '.' : ',';
    var parts = v.toFixed(dec ? 2 : 0).split('.');
    var out = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, /[.,]\d{3}/.test(m[0].replace(/[.,]\d{2}$/, '')) ? thou : '') + (dec ? dec + parts[1] : '');
    return clean(s.replace(m[0], out));
  }
  function saves() {
    document.querySelectorAll('#cart-drawer .cart__item').forEach(function (item) {
      var price = item.querySelector('.cart__price'); if (!price) return;
      var ins = price.querySelector('ins'), del = price.querySelector('del'), q = item.querySelector('.cart__quantity-field');
      var qty = q ? Math.max(1, parseInt(q.value, 10) || 1) : 1;
      var diff = ins && del ? (num(del.textContent) - num(ins.textContent)) * qty : 0;
      var el = item.querySelector('.cd-save');
      if (diff > 0.004) {
        var txt = '(' + (cfg.save || 'Save') + ' ' + fmt(diff, ins.textContent) + ')';
        if (!el) { el = document.createElement('p'); el.className = 'cd-save'; price.insertAdjacentElement('afterend', el); }
        if (el.textContent !== txt) el.textContent = txt;
      } else if (el) el.remove();
    });
  }
  var queued = false;
  function run() { try { footer(); } catch (e) {} try { saves(); } catch (e) {} }
  function refresh() { if (queued) return; queued = true; setTimeout(function () { queued = false; run(); }, 30); }
  function start() {
    run(); tick();
    setInterval(function () { tick(); run(); }, 1000);
    new MutationObserver(refresh).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
